module.exports = __webpack_public_path__ + "static/04-collaboration@2x-900778ae1ac106accc97a2a419132a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/04-collaboration@2x.jpg
// module id = 2644
// module chunks = 35783957827783